import { usePromociones } from "../context/PromocionesContext";

export const usePromocionesMock = () => usePromociones();
